import React,{useState} from 'react'
import './style.css'
import QubisaForum from 'assets/image/qubisa-forum.png'
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import LoginBg from 'assets/image/login-bg.png'
import InputMask from 'react-input-mask'
import { isMobile } from 'react-device-detect';
import { forumAuth, loginForum2, registerForum } from 'redux/actions/auth';
import { useDispatch,useSelector } from 'react-redux';
import {CircularProgress} from '@material-ui/core'
import { getForumFilter } from 'redux/actions/forum';
import { setPersist } from 'redux/actions/persist';
import { withRouter,useParams } from 'react-router-dom';
const LoginField=({state,settab,setpasswordtoggle1,passwordtoggle1,onChange,onLogin,isLoading,error})=>(
    <div>
        {error!==''&&<div className='error-msg'>
            <p className='font-lato margin-0'>{error}</p>
        </div>}
        <form onSubmit={onLogin}>
         <div>
            <p className='login-label font-lato margin-0'>Username / Email</p>
            <input key="userName" id="userName"  name="userName" value={state.userName} onChange={onChange} required className='login-input'/>
        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Kata Sandi</p>
            <div className='login-password'>
                <input name="password" onChange={onChange} value={state.password} onChange={onChange} required className='login-input' type={passwordtoggle1?'text':'password'}/>
                {passwordtoggle1?
                    <VisibilityOffIcon className='login-eye' onClick={()=>setpasswordtoggle1(!passwordtoggle1)}/>
                :
                    <VisibilityIcon className='login-eye' onClick={()=>setpasswordtoggle1(!passwordtoggle1)}/>
                }
            </div>
        </div>
        <br/>
        
        <div style={{textAlign:'right',marginBottom:10}}>
            <a href="https://www.qubisa.com/forgot-password"><p className='font-lato margin-0' style={{color:'#ff4e4e',fontSize:12}}>Lupa Kata Sandi?</p></a>
        </div>
        <button type="submit" className='btn-login' disabled={isLoading}>
            {isLoading?
                <CircularProgress style={{color:'white'}}  size={25} />
            :"Masuk"}
        </button>
        <br/><br/>
        </form>
        <p style={{fontSize:12}} className='font-lato margin-0'>Belum punya akun? <span style={{color:'#ff4e4e',cursor:'pointer'}} onClick={()=>settab('register')}>Daftar</span></p>
    </div>
)
const RegisterField=(props)=>{
    const {
        state,
        settab,
        onChange,
        onRegister,
        onChangePassword,
        onPasswordBlur,
        passworderror,
        repassworderror,
        isLoading,
        handleRegisterDisable,
        errorregister
    }=props

    const [passwordtoggle1, setpasswordtoggle1] = useState(false)
    const [passwordtoggle2, setpasswordtoggle2] = useState(false)
    return(
    <div>
         {errorregister!==''&&<div className='error-msg'>
            <p className='font-lato margin-0'>{errorregister}</p>
        </div>}
        <form onSubmit={onRegister}>
            
         <div>
            <p className='login-label font-lato margin-0'>Nama Lengkap</p>
            <input name="firstName" value={state.firstName} onChange={onChange} required className='login-input'/>
            <p style={{fontSize:10}} className='font-lato margin-0'>Pastikan nama lengkap sesuai KTP. Nama lengkap akan tertera pada e-sertifikat.</p>
        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Email</p>
            <input name="email" value={state.email} onChange={onChange} required type="email" className='login-input'/>
        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Username</p>
            <input name="userName" value={state.userName} onChange={onChange} required className='login-input'/>
        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Kata Sandi</p>
            <div className='login-password'>
                <input onBlur={()=>onPasswordBlur('password')} name="password" value={state.password} onChange={onChangePassword} required className='login-input' type={passwordtoggle1?'text':'password'}/>
                {passwordtoggle1?
                    <VisibilityOffIcon className='login-eye' onClick={()=>setpasswordtoggle1(!passwordtoggle1)}/>
                :
                    <VisibilityIcon className='login-eye' onClick={()=>setpasswordtoggle1(!passwordtoggle1)}/>
                }
            </div>
            {passworderror!==''&&<p className='field-error font-lato'>{passworderror}</p>}

        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Konfirmasi Kata Sandi</p>
            <div className='login-password'>
                <input onBlur={()=>onPasswordBlur('repassword')} name="repassword" value={state.repassword} onChange={onChangePassword} required className='login-input' type={passwordtoggle2?'text':'password'}/>
                {passwordtoggle2?
                    <VisibilityOffIcon className='login-eye' onClick={()=>setpasswordtoggle2(!passwordtoggle2)}/>
                :
                    <VisibilityIcon className='login-eye' onClick={()=>setpasswordtoggle2(!passwordtoggle2)}/>
                }
            </div>
            {repassworderror!==''&&<p className='field-error font-lato'>{repassworderror}</p>}
        </div>
        <br/>
        <div>
            <p className='login-label font-lato margin-0'>Nomor Handphone</p>
            <InputMask
                mask="9999-9999-9999-9999"
                maskChar={null}
                // onChange={null}
                name="phone"
                id="phone"
                value={state.phone} 
                onChange={onChange}
                // value={emp.phone}
            >
            {() =>
                <input name="phone"  required className='login-input'/>
            }
            </InputMask>
        </div>
        <br/>
        <button disabled={handleRegisterDisable()} type="submit" className='btn-login'>
            {isLoading?
                <CircularProgress style={{color:'white'}}  size={25} />
            :"Masuk"}
        </button>
        </form>
        <br/><br/>
        <p style={{fontSize:12}} className='font-lato margin-0'>Dengan mendaftar maka kamu telah menyetujui <a style={{color:'#ff4e4e'}} href="https://www.qubisa.com/terms">Ketentuan Penggunaan</a> dan <a style={{color:'#ff4e4e'}} href="https://www.qubisa.com/terms/privacy">Kebijakan Privasi</a> dalam menggunakan website QuBisa.</p>
        <br/>
        <p style={{fontSize:12}} className='font-lato margin-0'>Sudah punya akun ?  <span style={{color:'#ff4e4e',cursor:'pointer'}} onClick={()=>settab('login')}>Masuk</span></p>

    </div>
    )
}
 function Index(props) {
    const dispatch = useDispatch()
    const general = useSelector(state => state.general)
    const [passwordtoggle1, setpasswordtoggle1] = useState(false)
    const [passwordtoggle2, setpasswordtoggle2] = useState(false)
    const [tab, settab] = useState('login')
    const [error, seterror] = useState('')
    const [errorregister, seterrorregister] = useState('')
    const [passworderror, setpassworderror] = useState('')
    const [repassworderror, setrepassworderror] = useState('')
    const [state, setstate] = useState({
        firstName:'',
        email:'',
        userName:'',
        password:'',
        repassword:'',
        phone:'',
        referral:'cdhx',
        devicedId:isMobile?2:1,
        remoteIpAddress:'',
    })
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });
    console.log('params.redirect', params.redirect)      
    const onChange=(e)=>{
        let {value,name}=e.target
        setstate({...state,[name]:value})
    }
    const onChangePassword=(e)=>{
        let {value,name}=e.target
        setstate({...state,[name]:value})
    }
    const handleRegisterDisable=()=>{
        if(state.firstName!==''&&state.userName!==''&&state.phone!==''&&passworderror===''&&repassworderror===''&&general.isLoadingTable===false){
            return false
        }else{
            return true
        }
    }
    // console.log(`repassworderror`, repassworderror)
    const onPasswordBlur=(key)=>{
        if(key==='password'){
            if(state.password.length<6){
                setpassworderror('Kata sandi terlalu pendek (minimal 6 karakter)')
            }else{
                setpassworderror('')
            }
        }else{
            if(state.repassword.length<6){
                setrepassworderror('Konfirmasi kata sandi terlalu pendek (minimal 6 karakter)')
            }else if(state.password!==state.repassword){
                setrepassworderror('Konfirmasi kata sandi tidak sama dengan kata sandi')

            }else{
                setrepassworderror('')
            }
        }
    }
    let dataLogin={
        userName:state.userName,
        password:state.password,
        os:'',
        deviceID:state.devicedId,
        sourceID:0,
        versionCode:0,
        versionName:''
    }
    let dataRegister={
        firstName:state.firstName,
        email:state.email,
        userName:state.userName,
        password:state.password,
        phone:state.phone,
        referral:state.referral,
        deviceID:state.devicedId,
        remoteIpAddress:'',
    }
    const onLogin=async (e)=>{
        e.preventDefault()
        
        let res=await dispatch(loginForum2(dataLogin))
        if(res){
            seterror('')
            let res2=await dispatch(getForumFilter(res.data.accessToken.token))
            if(res2){
                let {home}=res2.data
                await dispatch(forumAuth(home[0].forumId,res.data.accessToken.token))

                dispatch(setPersist({filter_action:'home'}))
                dispatch(setPersist({forum_id:home[0].forumId}))
            }
            if(params.redirect){
                window.location.assign(params.redirect)
            }else{
                window.location.assign('/forum')
            }
        }else{
            seterror('Invalid username or password.')
        }
    }
    
    const onRegister=async (e)=>{
        e.preventDefault()
        
        let res=await dispatch(registerForum(dataRegister))
        if(res){
            seterrorregister('')
            
            let res2=await dispatch(loginForum2(dataLogin))
            if(res2){
                let res3=await dispatch(getForumFilter(res2.data.accessToken.token))
                if(res3){
                    let {home}=res3.data
                    await dispatch(forumAuth(home[0].forumId,res2.data.accessToken.token))

                    dispatch(setPersist({filter_action:'home'}))
                    dispatch(setPersist({forum_id:home[0].forumId}))
                }
            }
            if(params.redirect){
                window.location.assign(params.redirect)
            }else{
                window.location.assign('/forum')
            }
        }else{
            seterrorregister('Error registering user.')
        }
    }
    return (
        <div>
            <br/>
            <div className='login-container' style={{alignItems:tab==='login'?'center':'flex-start'}}>
                <div className='login-card'>
                    <div className='login-head'>
                        <img src={QubisaForum} alt="QuBisa"/>
                    </div>
                    <div className='login-hr'></div>
                    <div className='login-field'>
                    
                        {tab==='login'?
                            <LoginField 
                                setpasswordtoggle1={setpasswordtoggle1} 
                                passwordtoggle1={passwordtoggle1}
                                settab={settab}
                                onChange={onChange}
                                state={state}
                                onLogin={onLogin}
                                isLoading={general.isLoadingTable}
                                error={error}
                            />
                        :
                            <RegisterField
                                setpasswordtoggle1={setpasswordtoggle1} 
                                setpasswordtoggle2={setpasswordtoggle2} 
                                passwordtoggle1={passwordtoggle1}
                                passwordtoggle1={passwordtoggle2}
                                settab={settab}
                                onChange={onChange}
                                state={state}
                                onRegister={onRegister}
                                isLoading={general.isLoadingTable}
                                errorregister={errorregister}
                                onChangePassword={onChangePassword}
                                onPasswordBlur={onPasswordBlur}
                                passworderror={passworderror}
                                repassworderror={repassworderror}
                                handleRegisterDisable={handleRegisterDisable}
                            />
                        }
                    </div>
                </div>
                <img src={LoginBg} alt="QuBisa" className='login-bg'/>
            </div>
            <br/>
        </div>
    )
}
export default withRouter(Index)